export const getUrlParam = paramName => {
  const urlParams = new URLSearchParams(window.location.search);
  const param = urlParams.get(paramName);
  if (param !== null) {
    return param;
  }
  return '';
};
